module.exports = __webpack_public_path__ + "static/adele-979ac33c200b776b35201aacfb802ee2.svg";